// extracted by mini-css-extract-plugin
module.exports = {"primarycontainer_Promo":"Promo_primarycontainer_Promo__3tIdd","secondaryContainer":"Promo_secondaryContainer__1tkja","container_multipleItem":"Promo_container_multipleItem__3wWvG"};